<template>
  <w-sliding-popup ref="slidingPopup" title="L4 세션 상태 추가" width="600px">
    <el-form ref="statusForm" :model="statusForm" :rules="rules" slot="content">
      <el-form-item label="상태명" prop="statusValue">
        <el-input v-model="statusForm.statusValue" placeholder="상태명을 입력해주세요."></el-input>
      </el-form-item>
    </el-form>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" type="solid" class="mr-r4" @click="onClickSaveLfourSessionButton">저장</el-button>
      <el-button size="large" @click="close()">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import { isNil, isUndefined } from 'lodash';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import msgUtil from '@/utils/message';

export default {
  name: 'WLfourSessionAddSlidingPopup',
  data() {
    return {
      statusForm: {
        statusValue: '',
      },
      rules: {
        statusValue: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
          },
        ],
      },
      formName: 'statusForm',
      objCompanyInfo: {},
      messageTypeName: 'L4 세션 상태',
    };
  },
  methods: {
    /**
     * [L4 세션 상태를 추가하기 위한 팝업창을 띄운다.]
     * @author {Song}
     */
    open(objCompanyInfo) {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs[this.formName].resetFields();
        this.objCompanyInfo = objCompanyInfo;
      });
    },
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * [L4 세션 상태를 추가한다.]
     * @author {Song}
     */
    onClickSaveLfourSessionButton() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const params = {
            ...this.objCompanyInfo,
            statusValue: this.statusForm.statusValue,
          };
          netdeviceTableInfoAPI.insertLfourSessionStatusList(params).then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, this.messageTypeName, true));
              this.$emit('reload-data');
              this.close();
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, this.messageTypeName, true));
            }
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, this.messageTypeName, false));
          });
        }
      });
    },
    /**
     * [L4 상태명 유효성 검사 - 널 체크, 중복검사]
     * @author {Song}
     */
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error('값을 입력해주세요.'));
      } else {
        // 입력한 데이터에 대한 중복검사
        const params = {
          ...this.objCompanyInfo,
          statusValue: value,
        };
        netdeviceTableInfoAPI.getDuplicateCheckLfourStatus(params).then((res) => {
          if (res.data.success) {
            if (res.data.data) {
              // true면 중복 데이터 없는 것으로 판단
              callback();
            } else {
              callback(new Error('중복된 상태명이 존재합니다.'));
            }
          } else {
            this.$message(msgUtil.getCustomResultMsgData('L4 세션 상태 조회에 실패하였습니다.', false));
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/button/LfourSessionAddSlidingPopup.vue